import { Line as RechartsLine } from 'recharts';

export const Line = (
    props: React.ComponentProps<typeof RechartsLine>
) => {
    return <RechartsLine data-testid={'Line-container'} {...props} />;
};

export default Line;
